import React from 'react'
import { Upload } from 'element-react'

const UploadSG = () => {
    return (
        <Upload
            className="upload-demo"
            drag
            action="//jsonplaceholder.typicode.com/posts/"
            multiple
            tip={
                <div className="el-upload__tip">
                    jpg/png files with a size less than 500kb
                </div>
            }
        >
            <i className="el-icon-upload"></i>
            <div className="el-upload__text">
                Drop file here or <em>click to upload</em>
            </div>
        </Upload>
    )
}

export default UploadSG
